const matchRegExp = /[.*+?^${}()|[\]\\]/g;

export default function regexEscape(s) {
  return s.replace(matchRegExp, '\\$&');
}
